import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import VueRecomputed from "vue-recomputed"
import Notifications from 'vue-notification'
import moment from "moment"
import VueI18n from 'vue-i18n'
import ChordProJson from "./plugins/chordproJson"

Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(VueRecomputed);
Vue.use(Notifications);
Vue.use(VueI18n);
Vue.use(ChordProJson)

Vue.notify({
	position: "left bottom"
});

const messages = {
	cs: {
		global: {
			domain: "mangozpevnik.cz",
			mangoSongbook: "Mango Zpěvník",
			claim: {
				claim1: "Konečně",
				claim2: "super jednoduchý český",
				claim3: "zpěvník.",
			},
			close: "Zavřít"
		},
		error: {
			checkInternet: "Zkontrolujte, prosím, své připojení k internetu.",
			fillEmail: "Vyplňte prosím přihlašovací e-mail.",
			fillPassword: "Vyplňte prosím přihlašovací heslo.",
			lostFillPassword: "Zadejte prosím e-mail účtu, kterému chcete restartovat heslo.",
			wrongPassword: "Přihlašovací heslo není správné.",
			emailInvalid: "Přihlašovací e-mail není validní.",
			emailDoesntExist: "Uživatel s tímto e-mailem neexistuje. Zaregistrujte se."
		},
		success: {
			login: "Jsi úspěšně přihlášen.",
			logout: "Uživatel odhlášen.",
			playedSongsRefreshed: "Obnoveny informace o odehraných písničkách za posledních 12 hodin.",
			defaultTransposeChanged: "Transpozice nastavena jako výchozí."
		},
		user: {
			login: "Přihlášení",
			loginButton: "Přihlásit se",
			registration: "Registrace",
			registrationButton: "Registrovat se",
			inputYourEmail: "Zadejte váš e-mail",
			password: "Heslo",
			lostPassword: "Zaslat nové heslo",
			logoutButton: "Odhlásit se",
			anonymousButton: "bez přihlášení"
		},
		playlist: {
			create: "Vytvořit playlist",
			title: "Název playlistu",
			created: "Playlist vytvořen.",
			deleted: "Playlist odstraněn.",
			playlists: "Playlisty",
			createButton: "vytvořit playlist",
			removeButton: "odstranit",
			renamed: "Playlist přejmenován.",
			songNoPlaylistText: "Tady si můžeš písničku vložit do playlistu. Nejdříve si ale musíš nějaký playlist vytvořit."
		},
		song: {
			confirmDeleteSong: "Opravdu odstranit píseň z vašeho zpěvníku?",
			deleteCancelButton: "Zrušit",
			deleteSongButton: "Odstranit písničku",
			source: "Zdroj",
			songIsChecked: "Písnička je připravena a zkontrolována naším editorem.",
			scrolling: "scrolování",
			saveChanges: "Uložit změny",
			cancelButton: "Zrušit",
			addToSongbook: "Přidat do zpěvníku",
			queue: {
				title: "Fronta",
				add: "Přidat do fronty",
				done: "Hotovo",
				cancel: "Zrušit"
			},
			addSong: "Přidat písničku",
			allSongs: "Všechny písničky",
			queueSongs: "Písničky ve frontě",
			createPlaylistButton: "Vytvořit playlist",
			playlists: "Playlisty",
			authors: "Autoři",
			filter: {
				nonPlayed: "zobrazuji jen 12 hodin<br>nehrané písně",
				sorting: "řazení písniček<br>chytni a přesuň"
			},
			setTransposeDefault: "nastavit jako výchozí"
		},
		search: {
			button: "Vyhledávání",
			placeholderInputName: "Zadejte název nebo část textu",
			searching: "vyhledávám",
			helper1: "Zde můžeš přidat písničku z externích komunitních zdrojů.",
			helper2: "Napiš název nebo část textu.",
			createNewSongButton: "Vytvořit novou písničku"
		},
		localSearch: {
			placeholderInputNameLonger: "Zadejte název nebo část textu hledané písničky ...",
			placeholderInputNameShorter: "Zadejte část hledaného textu ...",
			queueButton: "Do fronty"
		},
		needMembershipModal: {
			text: "Pro vložení více jak 20 písniček do zpěvníku musíš mít premium verzi.",
			premiumButton: "Více o premium verzi",
			cancelButton: "Zrušit",
		},
		lookSettings: {
			title: "Vzhled",
			lightMode: "Denní režim",
			darkMode: "Noční režim"
		},
		membershipModal: {
			title: "Členství",
			noMembership: "V tuto chvíli nemáš žádné členství.",
			noMembershipText1: "Ve verzi zdarma máš přístupné všechny funkce jako v premium verzi. Jediné omezení je v počtu písniček, které si do svého zpěvníku můžeš uložit.",
			noMembershipText2: "Chceš-li mít ve svém zpěvníku více písniček, předplať si premium verzi.",
			membershipButton: "Předplatit",
			price: "{price} Kč / měsíc",
			moreOnWebsite: "Více se dozvíš <a href=\"https://mangozpevnik.cz\" target=\"_blank\">v ceníku</a>.",
			yourMembershipExpire: "Tvé premium členství je platné do",
			yourMembershipResumption1: "Dne",
			yourMembershipResumption2: "dojde pomocí automatické platby k prodloužení členství o další měsíc.",
			yourMembershipCancelled1: "Vaše členství je zrušeno.",
			yourMembershipCancelled2: "dojde k jeho zániku.",
			thanksForSupport: "Děkujeme za podporu Mango zpěvníku!",
			support: "Máš-li nějaké dotazy nebo připomínky, piš na",
			cancelMembershipButton: "Zrušit členství",
			cancelMembershipConfirm: "Opravdu chcete zrušit své členství?"
		},
		session: {
			title: "Sdílení session",
			claim: "Sdílejte aktuálně hranou písničku se svými kamarády.",
			helper: "Začněte tím, že tuto session pojmenujete. Použijte prosím jen znaky abecedy bez diakritiky.",
			nameLabel: "Jméno session",
			namePlaceholder: "Vložte jméno session",
			createButton: "Vytvořit a sdílet session",
			shareButton: "Sdílet odkaz na session",
			cancelButton: "Ukončit session",
			share: {
				title: "Mango Zpěvník",
				text: "Sdílení právě hrané písničky",
				dialogTitle: "Sdílej s ostatními živě co hraješ"
			}
		},
		menu: {
			playlists: "Playlisty",
			look: "Vzhled",
			control: "Ovládání",
			sessions: "Sdílení session",
			membership: "Členství",
			user: "Uživatel",
			export: "Export"
		},
		userSettingsModal: {
			title: "Nastavení uživatele",
			loggedUser: "Přihlášený uživatel",
			refreshPlayedSongs: "Obnovit odehrané písničky",
			logout: "Odhlásit se",
			deleteAccount: "Odstranit účet",
			deleteAccountConfirm: "Opravdu chcete odstranit účet? Přijdete o všechna svá data. Tento krok nelze vzít zpět."
		},
		updateModal: {
			ios: {
				title: "Aplikace je k dispozici v nové verzi.",
				text: "Aktualizujte Mango zpěvník v App Store. Získáte nové funkce a opravy chyb.",
				refreshButton: "Aktualizovat"
			},
			android: {
				title: "Aplikace je k dispozici v nové verzi.",
				text: "Aktualizujte Mango zpěvník v Google Play. Získáte nové funkce a opravy chyb.",
				refreshButton: "Aktualizovat"
			},
			web: {
				title: "Aplikace je k dispozici v nové verzi.",
				text: "Klikněte na tlačítko \"Obnovit aplikaci\" pro zaktivování nových funkcí, a opravu případných chyb.",
				refreshButton: "Obnovit aplikaci"
			}
		},
		exportModal: {
			title: "Export",
			exportButton: "Zaslat export na e-mail",
			text1: "Vyexportujte si všechny své uložené písničky. Export proběhne do formátů ChordPro a PDF. Exportovaný zpěvník můžete importovat do jiných aplikací, využít ho pro hromadný tisk, nebo vlastní způsob zálohování.",
			text2: "Finální export vám bude odeslán na e-mail",
			text3: "Vytvoření a zaslání exportu proběhne do několika minut."
		},
		side: {
			addSong: "Přidat písničku",
			allSongs: "Všechny písničky",
			queueSongs: "Písničky ve frontě"
		},
		notification: {
			songAddedToQueue: "Písnička přidána do fronty.",
			songPlayedFromQueue: "Písnička označena jako odehraná.",
			songRemovedFromQueue: "Písnička odstraněna z fronty.",
			songAddedToSongbook: "Písnička přidána do vašeho zpěvníku. Nyní bude dostupná i offline."
		},
		controlSettingsModal: {
			title: "Nastavení ovládání"
		}
	},








	en: {
		global: {
			domain: "mangozpevnik.cz",
			mangoSongbook: "Mango Songbook",
			claim: {
				claim1: "Finally",
				claim2: "really user friendly",
				claim3: "songbook app.",
			},
			close: "Close"
		},
		error: {
			checkInternet: "Check your internet connection, please.",
			fillEmail: "Fill in your e-mail, plase.",
			fillPassword: "Fill in your password, please.",
			lostFillPassword: "Fill your e-mail, please.",
			wrongPassword: "Your password is incorrect.",
			emailInvalid: "Invalid e-mail format, please check your e-mail address.",
			emailDoesntExist: "This e-mail does not belong to any account. Please, sign up."
		},
		success: {
			login: "Login successful.",
			logout: "User logout.",
			playedSongsRefreshed: "Information about songs played in last 12 hours were cleared.",
			defaultTransposeChanged: "Transpose set as default."
		},
		user: {
			login: "Login",
			loginButton: "Login",
			registration: "Registration",
			registrationButton: "Registration",
			inputYourEmail: "Input your e-mail",
			password: "Password",
			lostPassword: "Lost password",
			anonymousButton: "without registration"
		},
		playlist: {
			create: "Create playlist",
			title: "Playlist title",
			created: "Playlist was created.",
			deleted: "Playlist was deleted.",
			playlists: "Playlists",
			createButton: "create playlist",
			removeButton: "delete",
			renamed: "Playlist was renamed.",
			songNoPlaylistText: "Here you can add this song to the playlist. Create your playlist first, please."
		},
		song: {
			confirmDeleteSong: "This song will be deleted from your own songbook. Are you sure?",
			deleteCancelButton: "Cancel",
			deleteSongButton: "Delete song",
			source: "Source",
			songIsChecked: "The song is prepared and reviewed by our editor.",
			scrolling: "auto-scroll",
			saveChanges: "Save changes",
			cancelButton: "Cancel",
			addToSongbook: "Add to your songbook",
			queue: {
				title: "Queue",
				add: "Add to queue",
				done: "Done",
				cancel: "Cancel"
			},
			addSong: "Add song",
			allSongs: "All songs",
			queueSongs: "Songs in the queue",
			createPlaylistButton: "Create playlist",
			playlists: "Playlists",
			authors: "Artists",
			filter: {
				nonPlayed: "songs not played<br>in last 12 hours",
				sorting: "sorting songs<br>drag and drop"
			},
			setTransposeDefault: "set as default"
		},
		search: {
			button: "Search",
			placeholderInputName: "Search for lyrics or song title",
			searching: "searching",
			helper1: "Here you can add song from external sources (another websites).",
			helper2: "Search for lyrics or song title",
			createNewSongButton: "Create new song"
		},
		localSearch: {
			placeholderInputNameLonger: "Here you can find in lyrics or song titles ...",
			placeholderInputNameShorter: "Here you can find in lyrics ...",
			queueButton: "Queue it"
		},
		needMembershipModal: {
			text: "You reached limit of free membership. If you want add more than 20 songs to your songbook, subscribe premium membership, please.",
			premiumButton: "More about premium",
			cancelButton: "Cancel",
		},
		lookSettings: {
			title: "Appearance",
			lightMode: "Light mode",
			darkMode: "Dark mode"
		},
		membershipModal: {
			title: "Membership",
			noMembership: "Now you are using free membership.",
			noMembershipText1: "You can use all the same features in the free membership as in the premium one. Limitations are just in amount of songs added to your own songbook.",
			noMembershipText2: "If you want add more than 20 songs to your songbook, buy premium membership, please.",
			membershipButton: "Subscribe",
			price: "{price} € / month",
			moreOnWebsite: "More details <a href=\"https://mangosongbook.com\" target=\"_blank\">in pricing</a>.",
			yourMembershipExpire: "Your premium is valid until",
			yourMembershipResumption1: "Next automatic payment will be charged on",
			yourMembershipResumption2: ".",
			yourMembershipCancelled1: "Your membership was cancelled.",
			yourMembershipCancelled2: "you will lose access to premium features.", // predelat tak aby to bylo pred datem jeste "on"
			thanksForSupport: "Thanks for your support!",
			support: "Do you have same questions of requests? Mail me",
			cancelMembershipButton: "Unsubscribe",
			cancelMembershipConfirm: "Are you sure?"
		},
		session: {
			title: "Share session",
			claim: "Share currently played song with your friends.",
			helper: "Fill in your session title. Use only alphabet characters.",
			nameLabel: "Title of session",
			namePlaceholder: "Fill in title of session",
			createButton: "Create and share session",
			shareButton: "Share link to session",
			cancelButton: "End session",
			share: {
				title: "Mango Songbook",
				text: "Here is currently played song.",
				dialogTitle: "Share live with anyone what you play"
			}
		},
		menu: {
			playlists: "Playlist",
			look: "Appearance",
			control: "Control",
			sessions: "Share session",
			membership: "Membership",
			user: "User",
			export: "Export"
		},
		userSettingsModal: {
			title: "User settings",
			loggedUser: "Logged user",
			refreshPlayedSongs: "Refresh played songs",
			logout: "Logout out",
			deleteAccount: "Remove account",
			deleteAccountConfirm: "Are you sure you want to delete the account? You will lose all your data. This step cannot be undone."
		},
		updateModal: {
			ios: {
				title: "New update is available.",
				text: "Update Mango Songbook in App Store. You will get new features.",
				refreshButton: "Update"
			},
			android: {
				title: "New update is available.",
				text: "Update Mango Songbook in Google Play. You will get new features.",
				refreshButton: "Update"
			},
			web: {
				title: "New update is available.",
				text: "Click the button \"Refresh application\" for new features.",
				refreshButton: "Refresh application"
			}
		},
		exportModal: {
			title: "Export",
			exportButton: "Send export via e-mail",
			text1: "Export your all saved songs to ChordPro format and PDF. These exported files you can import to another applications, print or use for backup.",
			text2: "Generated files will be send automatically to your e-mail in a few more minutes.",
			text3: ""
		},
		side: {
			addSong: "Add song",
			allSongs: "All songs",
			queueSongs: "Songs in the queue"
		},
		notification: {
			songAddedToQueue: "Song added to queue.",
			songPlayedFromQueue: "Song marked as played.",
			songRemovedFromQueue: "Song removed from queue.",
			songAddedToSongbook: "A song added to your songbook. It will now be available offline."
		},
		controlSettingsModal: {
			title: "Control settings"
		}
	}
};

const localeInitValue = localStorage.getItem("language");
const i18n = new VueI18n({ locale: localeInitValue ? localeInitValue : "en", messages });

Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value)).format("D. M. YYYY")
	}
});

require("../node_modules/normalize.css/normalize.css");

new Vue({
	router,
	store,
	render: h => h(App),
	i18n
}).$mount('#app');

/* eslint-disable */

if (!router.currentRoute.path.includes("/export/")) {
	ga('set', 'page', router.currentRoute.path);
	ga('send', 'pageview');
}

router.afterEach(( to, from ) => {
	if (!to.path.includes("/export/")) {
		ga('set', 'page', to.path);
		ga('send', 'pageview');
	}
});
